import React from 'react'

import { motion } from 'framer-motion'

const values = [
  {
    icon: '🤝',
    title: "Integrity",
    description: "Conducting ourselves with honesty and transparency in all our interactions."
  },
  {
    icon: '🤖', 
    title: "Innovation",
    description: "Implementing creative solutions to meet the evolving needs of our clients."
  },
  {
    icon: '👨‍💼',
    title: "Customer Focus",
    description: "Helping our clients achieve their goals by providing exceptional service and support."
  },
  {
    icon: '🌏',
    title: "Teamwork",
    description: "Evaluating the power of collaboration to achieve common goals and drive success."
  },
  {
    icon: '🏗️',
    title: "Excellence",
    description: "Delivering high-quality results that exceed expectations and set industry standards."
  },
  {
    icon: '🛠',
    title: "Craftsmanship",
    description: "Pursuing mastery in our work, ensuring every detail is executed with precision and care."
  }
]

const CoreValues = () => {
  return (
    <motion.section
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
      className="cursor-pointer max-w-7xl mx-auto py-16 px-6 bg-[#29313F] text-white text-center rounded-xl shadow-md"
    >
      <h2 className="text-4xl font-bold mb-8 tracking-wide">
        What Makes Us Who We Are
      </h2>

      {/* Dynamic representation of the values */}
      <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8'>
        {values.map((value, index) => {
          return (
            <motion.div
              key={index}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
              className="bg-slate-50 p-8 rounded-2xl shadow-lg transform hover:scale-105 transition-all"
            >
              <div className='text-6xl mb-4'>{value.icon}</div>
              <h3 className='text-2xl text-[#29313f] font-semibold mb-4'>{value.title}</h3>
              <p className='text-lg text-[#29313f]'>{value.description}</p>
            </motion.div>
          )
        })}
      </div>
    </motion.section>
  )
}

export default CoreValues